import { render, staticRenderFns } from "./groupNode0.vue?vue&type=template&id=9d4e87fa&"
import script from "./groupNode0.vue?vue&type=script&lang=ts&"
export * from "./groupNode0.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports